var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex"
  }, [_vm._m(0), _c('div', {
    staticClass: "flex w-full grid grid-cols-4"
  }, _vm._l(_vm.trafficTags, function (tag) {
    return _c('div', {
      key: tag.id,
      staticClass: "w-full"
    }, [_c('YCheckbox', {
      staticClass: "flex items-center mr-2",
      attrs: {
        "id": tag.name,
        "value": !_vm.restrictedTagNames.includes(tag.name),
        "label": tag.name,
        "inline": true,
        "type": "info"
      },
      on: {
        "input": function (value) {
          return _vm.updateTag(value, tag.name);
        }
      }
    })], 1);
  }), 0), _c('div', {
    class: {
      invisible: !_vm.hasChanged
    }
  }, [_c('YButton', {
    staticClass: "mt-4",
    attrs: {
      "color": "blue",
      "isLoading": _vm.isUpdating
    },
    on: {
      "click": _vm.upsertTags
    }
  }, [_vm._v("Update Tags")])], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tag-row-label"
  }, [_vm._v(" Traffic Types "), _c('span', {
    staticClass: "text-xxs font-normal block"
  }, [_vm._v("Select Allowed Types")])]);

}]

export { render, staticRenderFns }